import { getMaxFileSize, showMaxFileSizeError, showStorageError } from '../services/plan-service';
import { createAlert } from '../services/alert-service';
import { getCurrentUserId } from '../services/store-service';
import * as FileService from '../services/file-service';
import * as FilesApi from '../api/files-api';

const DISABLED = false;

/**
 * Upload Files
 * @param  {[File]} files
 * @param  {[{ association, association_id }]} uploadConfig
 * @return {[Promise]}        [description]
 */
export const uploadFiles = ({ files, uploadConfig, onChange, onUpload }) => {
    const fileSizeQuota = getMaxFileSize();

    if (DISABLED) {
        showMaintenance();
        return Promise.reject();
    }

    files = files.filter(file => {
        if (file.size > fileSizeQuota) {
            showMaxFileSizeError(file);
            return false;
        }

        return true;
    });

    if (!files.length) {
        return Promise.reject();
    }

    return processFiles(files.sort((a, b) => a.name > b.name ? 1 : -1), uploadConfig)
        .then(fileObjects => handleProcessedFiles(fileObjects, onChange))
        .then(fileObjects => doUpload(fileObjects, uploadConfig))
        .then(uploadResponses => handleUploadedFiles(uploadResponses, onUpload))
        .catch(handleError);
}

const processFiles = (files, uploadConfig) => {
    const totalSize = files.reduce((totalSize, file) => totalSize + file.size, 0);

    return checkStorageLimit(totalSize)
        .catch(error => {
            if (error[0] && error[0].indexOf('File size exceeds the file size limit of a team' === 0)) {
                showStorageError();
            } else {
                createAlert('error', error[0] || '👨‍🔧 We are undergoing maintenance on file uploads and will have the feature back up shortly.');
            }

            const e = new Error(error[0]);
            e.handled = true;
            throw e;
        })
        .then(() => Promise.all(files.map(file => FileService.processFile(file).then(response => ({
            file: response.file,
            thumbnail: response.base64,
            url: response.base64,
            download: response.base64,
            created_at: new Date(),
            name: response.name,
            contentLength: response.contentLength,
            contentType: response.contentType,
            association: uploadConfig ? uploadConfig.association : undefined,
            association_id: uploadConfig ? uploadConfig.association_id : undefined
        })))));
}

export const checkStorageLimit = totalSize => FilesApi.checkStorageLimit(totalSize)
    .then(({ uploadable }) => {
        if (!uploadable) {
            throw new Error('Not enough storage');
        }
    })
    .catch(error => {
        showStorageError();
        throw new Error('Not enough storage');
    });


const showMaintenance = () => {
    createAlert('error', '👨‍🔧 We are undergoing maintenance on file uploads and will have the feature back up shortly.');
}

const handleProcessedFiles = (fileObjects, onChange) => {
    onChange && onChange(fileObjects);

    return fileObjects;
}

const doUpload = (fileObjects, uploadConfig) => {
    if (!uploadConfig || typeof uploadConfig !== 'object') {
        return Promise.resolve();
    }

    return FileService.uploadFiles(fileObjects.sort((a, b) => a.name > b.name ? 1 : -1).reverse().map(fileObject => ({
        ...fileObject,
        uploader: getCurrentUserId()
    })));
}

const handleUploadedFiles = (uploadResponses, onUpload) => {
    if (!uploadResponses) {
        return;
    }

    onUpload && onUpload(uploadResponses);

    return uploadResponses;
}

const handleError = error => {
    console.error(error);
}
